<div class="container-fluid">
    <div class="row pt-4 pl-4" style="font-size: 22px !important;
    font-weight: 400;
    color: #424242;">
      <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;User Data</h5>
      </div>

  <div  class="container">
    <div class="modal-body">
        <div class="row">
			<div class="col-md-4" *ngIf="hasAccess('My Leaves')">
			<div class="card shadow"  style="align-items: center;">
				<div class="card-body ">
                    <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:18px;" (click)="myLeavesClick()">
                        My Leaves
                </div>
          </div>
		  </div>
		  </div>


		  <div class="col-md-4" *ngIf="hasAccess('My Holidays')">
		  <div class="card shadow" style="align-items: center;">
			<div class="card-body align-items-start">
                <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:18px;" (click)="myHolidaysClick()">
                    My Holidays
            </div>
          </div>
        </div>
		</div>

		<div class="col-md-4" *ngIf="hasAccess('Personal Details')">
        <div class="card shadow" style="align-items: center;">
		<div class="card-body align-items-start">
		    <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:18px;" (click)="personalDetailsClick()">
                Personal Details
        </div>
          </div>
      </div>
      </div>
	  </div>

      <div class="row pt-4">
        <div class="col-md-4" *ngIf="hasAccess('Official Details')">
        <div class="card shadow"  style="align-items: center;">
            <div class="card-body ">
                <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:18px;" (click)="officialDetailsClick()">
                   Official Details
            </div>
      </div>
      </div>
      </div>


      <div class="col-md-4" *ngIf="hasAccess('CTC Details') && userType !== 'Article'">
      <div class="card shadow"  style="align-items: center;">
        <div class="card-body align-items-start">
            <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:18px;" (click)="CTCDetailsClick()">
               CTC Details
        </div>
      </div>
    </div>
    </div>

    <div class="col-md-4" *ngIf="hasAccess('Exit Form')">
    <div class="card shadow" style="align-items: center;">
    <div class="card-body align-items-start">
        <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:18px;" (click)="exitFormClick()">
            Exit Form
    </div>
      </div>
  </div>
  </div>
  </div>

  <div class="row pt-4" >
    <div class="col-md-4" *ngIf="hasAccess('Know Your Colleagues')">
    <div class="card shadow"  style="align-items: center;">
        <div class="card-body ">
            <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:18px;" (click)="knowYourColleaguesClick()">
              Know Your Colleagues
        </div>
  </div>
  </div>
  </div>


  <div class="col-md-4" *ngIf="hasAccess('Know Your Clients')">
  <div class="card shadow" style="align-items: center;">
    <div class="card-body align-items-start">
        <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:18px;" (click)="knowYourClientsClick()">
           Know Your Clients
    </div>
  </div>
</div>
</div>

</div>
     </div>
	 </div>

  